import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FaBars, FaCartPlus } from "react-icons/fa";
import "../assets/css/Header.scss";
import { useSelector } from "react-redux";

const Header = () => {
  const { cartItems } = useSelector((state) => state.cartReducer);
  var [userName, setUserName] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    getUserName();
  });

  const getUserName = () => {
    if (localStorage.getItem("currentUser")) {
      const { user } = JSON.parse(localStorage.getItem("currentUser"));
      setUserName(user.email.split("@")[0]);
    } else {
      setUserName("");
    }
  };

  const logout = () => {
    localStorage.removeItem("currentUser");
    navigate("/login");
  };

  return (
    <div className="header_main">
      <div className="header_content">
        <nav className="header_nav navbar navbar-expand-lg navbar-light">
          <div className="header_container container-fluid">
            <Link to="/" className="navbar-brand">
              <div className="brand">
                <p>DELTAfoods</p>
                <span>Farm to Home</span>
              </div>
            </Link>
            <button
              className="navbar-toggler"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarSupportedContent"
              aria-controls="navbarSupportedContent"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span>
                <FaBars size={25} />
              </span>
            </button>
            <div
              className="header_right collapse navbar-collapse"
              id="navbarSupportedContent"
            >
              <ul className="navbar-nav ms-auto">
                <li className="nav-item">
                  <Link to="/about" className="nav-link">
                    About
                  </Link>
                </li>
                <li className="nav-item">
                  <Link to="/products" className="nav-link">
                    Products
                  </Link>
                </li>
                <li className="nav-item">
                  <Link to="/orders" className="nav-link">
                    Orders
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    to="/cart"
                    className="nav-link d-flex align-items-center"
                  >
                    <FaCartPlus />
                    <div className="cart-total">{cartItems.length}</div>
                    <span>Cart</span>
                  </Link>
                </li>
                {userName === "" && (
                  <li className="nav-item dropdown">
                    <a
                      className="nav-link dropdown-toggle"
                      href="#"
                      id="navbarDropdown"
                      role="button"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      User
                    </a>
                    <ul
                      className="dropdown-menu"
                      aria-labelledby="navbarDropdown"
                    >
                      <li>
                        <Link to="/login" className="dropdown-item">
                          Login
                        </Link>
                      </li>
                      <li>
                        <Link to="/register" className="dropdown-item">
                          Register
                        </Link>
                      </li>
                    </ul>
                  </li>
                )}
                {userName !== "" && (
                  <li className="nav-item dropdown">
                    <a
                      className="nav-link dropdown-toggle"
                      href="#"
                      id="navbarDropdown"
                      role="button"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      {userName}
                    </a>
                    <ul
                      className="dropdown-menu"
                      aria-labelledby="navbarDropdown"
                    >
                      {userName === "testuser" && (
                        <li>
                          <Link to="/admin" className="dropdown-item">
                            Admin Pannel
                          </Link>
                        </li>
                      )}
                      <li>
                        <Link to="/" className="dropdown-item" onClick={logout}>
                          Logout
                        </Link>
                      </li>
                    </ul>
                  </li>
                )}
              </ul>
            </div>
          </div>
        </nav>
      </div>
    </div>
  );
};

export default Header;
